if (document.querySelector(".pop-in")) {
	const targets = document.querySelectorAll(".pop-in");

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					entry.target.classList.add("show");
					observer.unobserve(entry.target); // 一度だけ発火（何回もやりたいなら削除）
				}
			});
		},
		{
			threshold: 0.2, // 要素が20%見えたら発火
		}
	);

	targets.forEach((target) => observer.observe(target));
}
